import { vars } from "@imwebme/clay-token";
import type { PropsWithChildren } from "react";
import { Flex } from "../utilities";

export const ProgressBarContainer = ({ children }: PropsWithChildren) => (
  <Flex alignItems="center" gap={vars.spacing[2]} padding={`${vars.spacing["05"]} 0`}>
    {children}
  </Flex>
);
